/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliParentInvitationPreviewDto } from '../../models/amoxcalli-parent-invitation-preview-dto';

export interface ApiParentInvitationsPreviewGet$Json$Params {
  token?: string;
}

export function apiParentInvitationsPreviewGet$Json(http: HttpClient, rootUrl: string, params?: ApiParentInvitationsPreviewGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliParentInvitationPreviewDto>> {
  const rb = new RequestBuilder(rootUrl, apiParentInvitationsPreviewGet$Json.PATH, 'get');
  if (params) {
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliParentInvitationPreviewDto>;
    })
  );
}

apiParentInvitationsPreviewGet$Json.PATH = '/api/parent-invitations/preview';
